import { render, staticRenderFns } from "./CredenciamentoAtualizacaoLotesItens.vue?vue&type=template&id=b5afc4a2"
import script from "./CredenciamentoAtualizacaoLotesItens.vue?vue&type=script&lang=js"
export * from "./CredenciamentoAtualizacaoLotesItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports